import { render } from "./Receiver.vue?vue&type=template&id=1d98217a&scoped=true"
import script from "./Receiver.vue?vue&type=script&lang=js"
export * from "./Receiver.vue?vue&type=script&lang=js"

import "./Receiver.vue?vue&type=style&index=0&id=1d98217a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d98217a"]])

export default __exports__